import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const o = l((c, a) => /* @__PURE__ */ s.jsx(
  r,
  {
    ref: a,
    ...c,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3560",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M8 3.99c.41 0 .75-.34.75-.75V.75C8.75.34 8.41 0 8 0s-.75.34-.75.75v2.49c0 .41.33.75.75.75M8 5C6.35 5 5 6.34 5 8s1.35 3 3 3 3-1.35 3-3-1.34-3-3-3m0 4.5c-.82 0-1.5-.68-1.5-1.5S7.18 6.5 8 6.5s1.5.67 1.5 1.5S8.83 9.5 8 9.5M8 12c-.41 0-.75.34-.75.75v2.49c0 .41.34.75.75.75s.75-.34.75-.75v-2.49c0-.41-.34-.75-.75-.75M4.12 5.18a.75.75 0 1 0 1.06-1.06L3.4 2.34a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06zM11.9 10.84a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.75 1.75c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06zM11.4 5.34c.19 0 .38-.07.53-.22l1.72-1.72c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.72 1.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22M4.15 10.78l-1.8 1.8c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l1.8-1.8c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0M4.02 8c0-.41-.34-.75-.75-.75H.75a.749.749 0 1 0 0 1.5h2.52c.42 0 .75-.34.75-.75M15.24 7.25h-2.47c-.41 0-.75.34-.75.75s.34.75.75.75h2.47c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3560)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencySunIcon";
export {
  o as AgencySunIcon,
  o as default
};
//# sourceMappingURL=index.js.map
